import {
  FETCH_REVIEW,
  SUBMIT_REVIEW,
  DELETE_REVIEW,
  REFRESH_REVIEW_DATATABLES,
  RESET_STORE,
} from '../actions/_types';

const initialState = {
  result: [],
  submitResult: {},
  deleteResult: {},

  refresh: false,
};

export default function review(state = initialState, action) {
  switch (action.type) {
    case FETCH_REVIEW:
      return {
        ...state,
        result: action.result,
      };

    case SUBMIT_REVIEW:
      return {
        ...state,
        submitResult: action.result,
      };

    case DELETE_REVIEW:
      return {
        ...state,
        deleteResult: action.result,
      };

    case REFRESH_REVIEW_DATATABLES:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case RESET_STORE:
      return { ...initialState };

    default:
      return state;
  }
}
